import React from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import HelpButton from './HelpButton';

const Start = ({ history: { push } }) => {
  const { t } = useTranslation();
  return (
    <Container fluid textAlign="center">
      <Header as="h1">
        {t('Do as more than half a million people have already done!')}
        {' '}
        <br />
        <h2>{t('Turn your used into CASH with MGU')} 💰</h2>
      </Header>
      <p>
      {t('Sell your games, consoles, notebooks, phones, and hardwares to MeuGameUsado and receive money (PIX) or store credit to use in our shops!')}
      </p>

      <Button
        color="green"
        className="fancy"
        id="start-quotation"
        onClick={() => push('/quotation')}
      >
        {t('Start quotation')}
      </Button>
      <HelpButton>{t('How does it works?')}</HelpButton>

      <div className="quotation-ai-option">
        <span>{t('Or make your quotation with our AI')}</span>
        <a
          className="quotation-ai-telegram"
          href="https://t.me/mgucotacoes_bot"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="telegram plane" />
          {t('Continue on Telegram')}
        </a>
      </div>

    </Container>
  );
};

export default withRouter(Start);
